import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { AutocompleteControl } from 'components/_basic/Form/Autocomplete';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { BorderedCard } from 'components/BorderedCard';
import { ISectionRowProps as IProps } from 'components/BusinessToolForm';
import { RISKS_OPTIONS_DEU } from 'components/BusinessToolForm/constants/deu/options_deu';
import { RISKS_OPTIONS_ES } from 'components/BusinessToolForm/constants/es/options_es';
import { RISKS_OPTIONS } from 'components/BusinessToolForm/constants/options';
import { RISKS_OPTIONS_UA } from 'components/BusinessToolForm/constants/ua/options_ua';

import { concatWithDot } from 'helpers/string';

import { LIST_OF_RISKS_NAMES } from '../utils/form';

export const ListOfRisks: FC<IProps> = memo(({ name, disabled = false }) => {
  const { control } = useFormContext();
  const { t, i18n } = useTranslation();

  const getChosenRiskOptions = (lang: string) => {
    switch (lang) {
      case 'de':
        return RISKS_OPTIONS_DEU;

      case 'uk':
        return RISKS_OPTIONS_UA;

      case 'es':
        return RISKS_OPTIONS_ES;

      default:
        return RISKS_OPTIONS;
    }
  };

  return (
    <BorderedCard>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextInputControl
            control={control}
            id={concatWithDot(name, LIST_OF_RISKS_NAMES.NAME)}
            name={concatWithDot(name, LIST_OF_RISKS_NAMES.NAME)}
            label={t('legalFrameworkAndRisks.listOfRisks.nameOfRisk')}
            disabled={disabled}
            maxLength={150}
          />
        </Grid>
        <Grid item xs={6}>
          <AutocompleteControl
            control={control}
            id={concatWithDot(name, LIST_OF_RISKS_NAMES.GROUP)}
            name={concatWithDot(name, LIST_OF_RISKS_NAMES.GROUP)}
            label={t('legalFrameworkAndRisks.listOfRisks.riskGroup')}
            options={getChosenRiskOptions(i18n.language)}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInputControl
            multiline
            control={control}
            id={concatWithDot(name, LIST_OF_RISKS_NAMES.NEGATIVE_IMPACT)}
            name={concatWithDot(name, LIST_OF_RISKS_NAMES.NEGATIVE_IMPACT)}
            label={t('legalFrameworkAndRisks.listOfRisks.negativeImpact')}
            maxLength={500}
            minRows={4}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInputControl
            multiline
            control={control}
            id={concatWithDot(name, LIST_OF_RISKS_NAMES.PREVENTION_MEASURES)}
            name={concatWithDot(name, LIST_OF_RISKS_NAMES.PREVENTION_MEASURES)}
            label={t('legalFrameworkAndRisks.listOfRisks.preventionMeasures')}
            maxLength={500}
            minRows={4}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </BorderedCard>
  );
});
